<script>
  import resources from './resources'
  import LOGIN_TO_PATIENT from '@/plugins/http/patient'

  export default {
    name: 'content-patient',
    mixins: [resources],
    data: () => {
      return {
        LOGIN_TO_PATIENT: LOGIN_TO_PATIENT
      }
    },
    methods: {
      goToLoginPatient () {
        location.href = this.LOGIN_TO_PATIENT
      }
    }
  }
</script>

<template lang="pug">
  div
    #switch-page.container-fluid
      .container
        router-link.pull-right.transition(:to="{ name: 'patient.loading-page.index'}")
          | Acesse a Área do Paciente
    #menu-wrapper.container-fluid
      .container
        #logo.col-sm-3.col-md-2
          router-link(:to="{ name: 'patient.loading-page.index'}")
           img(src='/static/images/logo.svg', width='164', height='50')
        ul#menu.col-sm-8.col-md-10
          a(href='', v-scroll-to="'#apresentacao'")
            li.apresentacao Apresentação
          a(href='', v-scroll-to="'#contato'")
            li.contato Contato
          a#login.pull-right.cursor-pointer(@click.prevent="goToLoginPatient()")
            | Entrar
            span.icon 
</template>
<style scoped>
  .cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/app/professional/loading-page/gadget/components/professional/content.vue